import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const PopularActionsWrapper = styled(FlexColumn)`
    width: 100%;
`;
export const PopularActionsBody = styled(FlexRow)`
    gap: 12px;
    width: 100%;
`;
export const PopularActionWrapper = styled.a`
    width: 100%;
    flex-direction: row;
    display: flex;
    cursor: pointer;
    padding-left: 16px;
    padding-right: 16px;
    height: 64px;
    background-color: rgb(236, 241, 255);
    align-items: center;
    border-radius: 6px;
    justify-content: space-between;
    transition: all ease-in 0.3s;
    &:hover {
        box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
        background-color: ${colorsPalettes.blue[100]};
    }
`;
export const Body = styled(FlexRow)`
    gap: 16px;
    align-items: center;
`;
export const Text = styled.div`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[500])}
`;
export const Image = styled.img`
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px;
    width: 32px;
    height: 32px;
    background: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.blue[200]};
    border-radius: 6px;
`;
